export default __webpack_public_path__ + "static/media/photo7.06827ed6.jpeg";